import { useEffect, useState } from 'react';
import classes from './SaveNotification.module.css';

export const SaveNotification = ({ show, onHide, message = "Änderungen gespeichert" }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      // Trigger animation by setting visible
      setIsVisible(true);
      // Auto-hide after 3 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
        // Wait for animation to complete before calling onHide
        setTimeout(() => {
          onHide();
        }, 300); // Match CSS transition duration
      }, 3000);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [show, onHide]);

  if (!show) return null;

  return (
    <div className={`${classes.notification} ${isVisible ? classes.visible : ''}`}>
      <div className={classes.notificationContent}>
        <div className={classes.checkmarkCircle}>
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.4859 0.848739L3.71939 9.18709L3.71922 9.18691L3.71839 9.18772L0 5.38934L0.837037 4.56993L3.74788 7.54339L11.6786 0L12.4859 0.848739Z" fill="white"/>
          </svg>
        </div>
        <span className="semiboldXs">{message}</span>
      </div>
    </div>
  );
};

export default SaveNotification;

